// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.SafetyGridSkeleton-safetyGridSkeletonContainer-RVWxP {
  padding: 35px 108px;
  background-color: var(--skeleton-primary-bg);
  border-radius: 0 24px 0 24px;
}

.SafetyGridSkeleton-safetyGridSkeletonWrapper-LgI0A {
  -webkit-box-align: center;
      -ms-flex-align: center;
          align-items: center;
  display: grid;
  grid-template-columns: 350px 1fr;
  gap: 20px;
}

.SafetyGridSkeleton-safetyGridSkeletonImgContainer-YRR7d {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
      -ms-flex-align: center;
          align-items: center;
  -webkit-box-pack: start;
      -ms-flex-pack: start;
          justify-content: flex-start;
}

.SafetyGridSkeleton-safetyGridSkeletonImg-bYhJg {
  max-width: 300px;
  height: 470px;
  background-color: var(--skeleton-secondary-bg);
  border-radius: var(--radius-4);
}

.SafetyGridSkeleton-safetyGridSkeletonHeading-adCeo {
  max-width: 539px;
  height: 46px;
  background-color: var(--skeleton-secondary-bg);
  border-radius: var(--radius-5);
}

.SafetyGridSkeleton-safetyGridSkeletonContent-Zsa04 {
  max-width: 411px;
  height: 28px;
  background-color: var(--skeleton-secondary-bg);
  border-radius: var(--radius-5);
  margin-top: 18px;
}

.SafetyGridSkeleton-safetyGridSkeletonBtnGrp-FUurK {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
      -ms-flex-align: center;
          align-items: center;
  -webkit-box-pack: start;
      -ms-flex-pack: start;
          justify-content: flex-start;
  -ms-flex-wrap: wrap;
      flex-wrap: wrap;
  gap: 12px;
  margin-top: 30px;
}

.SafetyGridSkeleton-safetyGridSkeletonBtn-BsILG {
  max-width: 168px;
  height: 52px;
  background-color: var(--skeleton-secondary-bg);
  border-radius: var(--radius-5);
}

@media (min-width:1200px) {
  .SafetyGridSkeleton-safetyGridSkeletonWrapper-LgI0A {
    grid-template-columns: 400px 1fr;
  }
}

@media (max-width:991px) {
  .SafetyGridSkeleton-safetyGridSkeletonContainer-RVWxP {
    padding: 35px 30px;
  }
}

@media (max-width:767px) {
  .SafetyGridSkeleton-safetyGridSkeletonContainer-RVWxP {
    padding: 35px 15px;
  }

  .SafetyGridSkeleton-safetyGridSkeletonWrapper-LgI0A {
    grid-template-columns: 100%;
  }

  .SafetyGridSkeleton-safetyGridSkeletonImg-bYhJg {
    height: 370px;
  }

  .SafetyGridSkeleton-safetyGridSkeletonHeading-adCeo {
    height: 32px;
  }

  .SafetyGridSkeleton-safetyGridSkeletonContent-Zsa04 {
    height: 24px;
    margin-top: 16px;
  }

  .SafetyGridSkeleton-safetyGridSkeletonBtnGrp-FUurK {
    margin-top: 24px;
  }

  .SafetyGridSkeleton-safetyGridSkeletonImgContainer-YRR7d {
    -webkit-box-pack: center;
        -ms-flex-pack: center;
            justify-content: center;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/Skeleton/Home/SafetyGridSkeleton/SafetyGridSkeleton.css"],"names":[],"mappings":"AAAA;EACE,mBAAmB;EACnB,4CAA4C;EAC5C,4BAA4B;AAC9B;;AAEA;EACE,yBAAmB;MAAnB,sBAAmB;UAAnB,mBAAmB;EACnB,aAAa;EACb,gCAAgC;EAChC,SAAS;AACX;;AAEA;EACE,oBAAa;EAAb,oBAAa;EAAb,aAAa;EACb,yBAAmB;MAAnB,sBAAmB;UAAnB,mBAAmB;EACnB,uBAA2B;MAA3B,oBAA2B;UAA3B,2BAA2B;AAC7B;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,8CAA8C;EAC9C,8BAA8B;AAChC;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,8CAA8C;EAC9C,8BAA8B;AAChC;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,8CAA8C;EAC9C,8BAA8B;EAC9B,gBAAgB;AAClB;;AAEA;EACE,oBAAa;EAAb,oBAAa;EAAb,aAAa;EACb,yBAAmB;MAAnB,sBAAmB;UAAnB,mBAAmB;EACnB,uBAA2B;MAA3B,oBAA2B;UAA3B,2BAA2B;EAC3B,mBAAe;MAAf,eAAe;EACf,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,8CAA8C;EAC9C,8BAA8B;AAChC;;AAEA;EACE;IACE,gCAAgC;EAClC;AACF;;AAEA;EACE;IACE,kBAAkB;EACpB;AACF;;AAEA;EACE;IACE,kBAAkB;EACpB;;EAEA;IACE,2BAA2B;EAC7B;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,YAAY;IACZ,gBAAgB;EAClB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,wBAAuB;QAAvB,qBAAuB;YAAvB,uBAAuB;EACzB;AACF","sourcesContent":[".safetyGridSkeletonContainer {\n  padding: 35px 108px;\n  background-color: var(--skeleton-primary-bg);\n  border-radius: 0 24px 0 24px;\n}\n\n.safetyGridSkeletonWrapper {\n  align-items: center;\n  display: grid;\n  grid-template-columns: 350px 1fr;\n  gap: 20px;\n}\n\n.safetyGridSkeletonImgContainer {\n  display: flex;\n  align-items: center;\n  justify-content: flex-start;\n}\n\n.safetyGridSkeletonImg {\n  max-width: 300px;\n  height: 470px;\n  background-color: var(--skeleton-secondary-bg);\n  border-radius: var(--radius-4);\n}\n\n.safetyGridSkeletonHeading {\n  max-width: 539px;\n  height: 46px;\n  background-color: var(--skeleton-secondary-bg);\n  border-radius: var(--radius-5);\n}\n\n.safetyGridSkeletonContent {\n  max-width: 411px;\n  height: 28px;\n  background-color: var(--skeleton-secondary-bg);\n  border-radius: var(--radius-5);\n  margin-top: 18px;\n}\n\n.safetyGridSkeletonBtnGrp {\n  display: flex;\n  align-items: center;\n  justify-content: flex-start;\n  flex-wrap: wrap;\n  gap: 12px;\n  margin-top: 30px;\n}\n\n.safetyGridSkeletonBtn {\n  max-width: 168px;\n  height: 52px;\n  background-color: var(--skeleton-secondary-bg);\n  border-radius: var(--radius-5);\n}\n\n@media (min-width:1200px) {\n  .safetyGridSkeletonWrapper {\n    grid-template-columns: 400px 1fr;\n  }\n}\n\n@media (max-width:991px) {\n  .safetyGridSkeletonContainer {\n    padding: 35px 30px;\n  }\n}\n\n@media (max-width:767px) {\n  .safetyGridSkeletonContainer {\n    padding: 35px 15px;\n  }\n\n  .safetyGridSkeletonWrapper {\n    grid-template-columns: 100%;\n  }\n\n  .safetyGridSkeletonImg {\n    height: 370px;\n  }\n\n  .safetyGridSkeletonHeading {\n    height: 32px;\n  }\n\n  .safetyGridSkeletonContent {\n    height: 24px;\n    margin-top: 16px;\n  }\n\n  .safetyGridSkeletonBtnGrp {\n    margin-top: 24px;\n  }\n\n  .safetyGridSkeletonImgContainer {\n    justify-content: center;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"safetyGridSkeletonContainer": `SafetyGridSkeleton-safetyGridSkeletonContainer-RVWxP`,
	"safetyGridSkeletonWrapper": `SafetyGridSkeleton-safetyGridSkeletonWrapper-LgI0A`,
	"safetyGridSkeletonImgContainer": `SafetyGridSkeleton-safetyGridSkeletonImgContainer-YRR7d`,
	"safetyGridSkeletonImg": `SafetyGridSkeleton-safetyGridSkeletonImg-bYhJg`,
	"safetyGridSkeletonHeading": `SafetyGridSkeleton-safetyGridSkeletonHeading-adCeo`,
	"safetyGridSkeletonContent": `SafetyGridSkeleton-safetyGridSkeletonContent-Zsa04`,
	"safetyGridSkeletonBtnGrp": `SafetyGridSkeleton-safetyGridSkeletonBtnGrp-FUurK`,
	"safetyGridSkeletonBtn": `SafetyGridSkeleton-safetyGridSkeletonBtn-BsILG`
};
module.exports = ___CSS_LOADER_EXPORT___;
